import Finance from '../views/finance/Index.vue';
import Costs from '../views/finance/Costs.vue';
import CostForm from '../views/finance/CostForm.vue';
import FinanceFees from '../views/finance/Fees.vue';
import Customers from '../views/finance/Customers.vue';
import CustomersList from '../views/finance/CustomersList.vue';
import Inventory from '../views/finance/Inventory.vue';
import InventoryPrint from '../views/finance/InventoryPrint.vue';
import InventorySettings from '../views/finance/InventorySettings.vue';
import Foreign from '../views/finance/Foreign.vue';
import ForeignSettings from '../views/finance/ForeignSettings.vue';
import ForeignPrint from '../views/finance/ForeignPrint.vue';
import { checkauth } from '../Helper';

const guard = (to, from, next) => {
	checkauth().then(response => (response ? next() : next('/login')));
};

export default [
	{ path: '/finance', name: 'finance', component: Finance, beforeEnter: guard },
	{ path: '/finance/costs', name: 'financeCosts', component: Costs, beforeEnter: guard },
	{ path: '/finance/costs/new', name: 'financeCostNew', component: CostForm, beforeEnter: guard },
	{ path: '/finance/costs/:id', name: 'financeCostEdit', component: CostForm, beforeEnter: guard },
	{ path: '/finance/fees', name: 'financeFees', component: FinanceFees, beforeEnter: guard },
	{ path: '/finance/customers', name: 'financeCustomers', component: Customers, beforeEnter: guard },
	{ path: '/finance/customers/list', name: 'financeCustomersList', component: CustomersList, beforeEnter: guard },
	{ path: '/finance/inventory', name: 'financeInventory', component: Inventory, beforeEnter: guard },
	{ path: '/finance/inventory/print', name: 'financeInventoryPrint', component: InventoryPrint, beforeEnter: guard },
	{ path: '/finance/inventory/settings', name: 'financeInventorySettings', component: InventorySettings, beforeEnter: guard },
	{ path: '/finance/foreign', name: 'financeForeign', component: Foreign, beforeEnter: guard },
	{ path: '/finance/foreign/settings', name: 'financeForeignSettings', component: ForeignSettings, beforeEnter: guard },
	{ path: '/finance/foreign/print', name: 'financeForeignPrint', component: ForeignPrint, beforeEnter: guard },
];
